import { SELECT_FILTER_VALUES } from "form/model"
import { CampaignAPI, LookupAPI } from "generated-api"

export const OTHER_ENVIRONMENT_GROUP_ID: number = -10

export type IEnvironmentDTO = Awaited<ReturnType<typeof LookupAPI.getApiVenueTypeList>>[0]
export type IEnvironment = Omit<IEnvironmentDTO, "dmi_code"> & {
  dmi_code: string
  parent: IEnvironment | null
  children: IEnvironment[]
  treeDepth: number // start at 0 = root
}
export type IEnvironmentAssociation = Awaited<ReturnType<typeof CampaignAPI.getApiCampaignVenuetypeList>>[0]

export interface IEnvironmentData {
  list: IEnvironment[]
  tree: IEnvironment[]
  environmentById: IEnvironmentById
}

export interface IEnvironmentRepository {
  getAllEnvironments(): Promise<IEnvironmentData>
  getEnvironmentsByName(name: string): Promise<IEnvironment[]>
  getEnvironmentsById(ids: number[]): Promise<IEnvironment[]>
  getCampaignEnvironments(campaignId: number): Promise<IEnvironmentAssociation[]>
  setEnvironments(campaignId: number, venue_type_ids: number[]): Promise<IEnvironmentAssociation[]>
  associateEnvironment(campaignId: number, venue_type_id: number): Promise<IEnvironmentAssociation>
  unassociateEnvironment(campaignId: number, associationId: number): Promise<void>
  getEnvironmentForecast(campaignId: number): Promise<IEnvironmentsForecast>
}

export interface IEnvironmentsSetFilterParams {
  name?: string
  selectFilter?: SELECT_FILTER_VALUES
}

export interface IEnvironmentById {
  [environementId: number]: IEnvironment
}

export type IEnvironmentState = IEnvironmentData

export interface IEnvironmentForecast {
  screen: number
  screenPercent: number
  screenTotal: number
  impression: number
  impressionPercent: number
  impressionTotal: number
  spendInCad: number
  spendTotalInCad: number
}

export interface IEnvironmentsForecast {
  [environmentId: number]: IEnvironmentForecast
}
